import React from 'react';
import { useEditorStore } from '../store/editorStore';
import { Trash2, AlertCircle, Info, AlertTriangle, CheckCircle } from 'lucide-react';

const Console: React.FC = () => {
  const { consoleMessages, clearConsole } = useEditorStore();

  const getIcon = (type: string) => {
    switch (type) {
      case 'error':
        return <AlertCircle size={16} className="text-red-500" />;
      case 'warn':
        return <AlertTriangle size={16} className="text-yellow-500" />;
      case 'info':
        return <Info size={16} className="text-blue-500" />;
      default:
        return <CheckCircle size={16} className="text-gray-400" />;
    }
  };

  const getMessageColor = (type: string) => {
    switch (type) {
      case 'error':
        return 'text-red-400';
      case 'warn':
        return 'text-yellow-400';
      case 'info':
        return 'text-blue-400';
      default:
        return 'text-gray-300';
    }
  };

  return (
    <div className="h-full bg-editor-bg border-t border-editor-border flex flex-col">
      <div className="flex items-center justify-between p-2 border-b border-editor-border">
        <h3 className="text-sm font-semibold text-gray-300">控制台</h3>
        <button
          onClick={clearConsole}
          className="p-1 hover:bg-editor-panel rounded text-gray-400 hover:text-gray-300 transition-colors"
          title="清空控制台"
        >
          <Trash2 size={16} />
        </button>
      </div>
      <div className="flex-1 overflow-auto p-2 font-mono text-sm">
        {consoleMessages.length === 0 ? (
          <div className="text-gray-500 text-center py-4">
            控制台输出将显示在这里...
          </div>
        ) : (
          consoleMessages.map((msg) => (
            <div key={msg.id} className="flex items-start gap-2 py-1 hover:bg-editor-panel px-2 rounded">
              <div className="pt-1">{getIcon(msg.type)}</div>
              <div className={`flex-1 ${getMessageColor(msg.type)}`}>
                <pre className="whitespace-pre-wrap break-words">
                  {typeof msg.content === 'string' ? msg.content : JSON.stringify(msg.content, null, 2)}
                </pre>
                <div className="text-xs text-gray-500 mt-1">
                  {new Date(msg.timestamp).toLocaleTimeString()}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Console;
